import React from 'react';

// Cauri "Ivoire" (style 1b de la maquette Claude Design) : coquillage ivoire,
// fente sombre, reflet. Version vide = contour pointillé.
const SHELL = 'M24 5C33.5 5 39 13.6 39 24S33.5 43 24 43 9 34.4 9 24 14.5 5 24 5Z';
const SLIT = 'M24 11C22 16 22 32 24 37C26 32 26 16 24 11Z';
const TEETH = 'M19.6 16H22.2M19 20.5H21.9M19 25H21.9M19 29.5H21.9M19.6 34H22.2M25.8 16H28.4M26.1 20.5H29M26.1 25H29M26.1 29.5H29M25.8 34H28.4';

interface CauriIconProps {
  filled?: boolean;
  size?: number;
  emptyColor?: string;
  className?: string;
}

const CauriIcon: React.FC<CauriIconProps> = ({ filled = true, size = 24, emptyColor = '#8A7358', className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {filled ? (
      <>
        <path d={SHELL} fill="#F0E3C6" stroke="#8A6D3B" strokeWidth="2" />
        <path d="M14 16C16 10 20 7.5 24 7.5" stroke="#FFF8EC" strokeWidth="2.4" />
        <path d={SLIT} fill="#2A1A12" />
        <path d={TEETH} stroke="#8A6D3B" strokeWidth="1.6" />
      </>
    ) : (
      <path d={SHELL} stroke={emptyColor} strokeWidth="2" strokeDasharray="3 4" />
    )}
  </svg>
);

export default CauriIcon;
